import localforage from 'localforage';

import { IDictionary } from '../types';
export interface PostDataType { [key: string]: string | JSON | number | boolean; }
// var CACHE_HITS = 0;
export interface CacheType { [key: string]: Response; }
const Cache = {
    responses: {} as CacheType,
    size: 0,
    add: function(key: string, response: Response) {
        Cache.size++;
        Cache.responses[key] = response;
    },
    get: function(key: string) {
        return Cache.responses[key] ? Cache.responses[key].clone() : null;
    }
};

function _url(path: string) {
	// https://backend-akllnm6qea-uc.a.run.app
	// Proxied dev stacks (orc + Traefik) set VITE_API_URL=/api; see orc/README.md.
	const server = import.meta.env.PROD ?
        "https://guac.fancyhands.com" :
        import.meta.env.VITE_API_URL ?
        new URL(import.meta.env.VITE_API_URL, window.location.origin).href.replace(/\/$/, "") :
        "http://127.0.0.1:4242";
	return `${server}${path}`;
}

async function  _fetch(path: string, _options: object) {
	const headers = {} as IDictionary;
	headers['Content-Type'] = 'application/json';
    //    console.log("_fetch accessing localforage");
	const access_token = await localforage.getItem("access_token") as string;
    //    console.log("_fetch accessed localforage");
	if(access_token) { 	headers['X-Access-Token'] = access_token; }
	const options = Object.assign({}, { headers:  headers }, _options);
	return fetch(_url(path), options)
}

async function api_post(path: string, data: PostDataType) {
	const options = { method: 'POST', body: JSON.stringify(data) };
	return _fetch(path, options);
}

async function api_get(url: string, data: IDictionary | undefined = undefined, debugging=false) {
    // we now accept a dictionary and will getify it.
    //    const cached = Cache.get(url);
    // if(cached) {
    //     CACHE_HITS++;
    //     console.log(`cache hit ${CACHE_HITS} for ${url}`);
    //     return cached;
    // }
    const path = url + (data ?  '?' + new URLSearchParams(data).toString() : '');
	const options = { method: 'GET' };
    if(debugging) {
        console.log("api_get", path);
    }
    return _fetch(path, options);
    // const copy = result.clone();
    // Cache.add(path, copy);
    // return result;
}

export { api_post, api_get };
